/**
 * Englische Kurzform der Vorschrift (englische Fassung des Mängelkatalogs,
 * 28.09.): rein, regelbasiert, idempotent. Übersetzt werden nur die
 * Verbindungswörter und Gliederungskürzel der deutschen Kurzform — die
 * Regelwerke selbst bleiben Eigennamen (DGUV V 38, DGUV R 101-038,
 * ASR A2.1, TRBS 2121, ArbStättV, DIN 4124 …), ebenso jeder Titel in
 * Anführungszeichen („Arbeiten im Spezialtiefbau“). Unbekanntes bleibt.
 *
 *   DGUV V 38 § 9 (2) i. V. m. DGUV R 101-038 Abschn. 9.2
 *   → DGUV V 38 § 9 (2) in conj. with DGUV R 101-038 Sect. 9.2
 */

/** Kein Buchstabe, keine Ziffer, kein Punkt davor (Wortanfang). */
const VOR = '(?<![\\p{L}\\p{N}.])';
/** Kein Buchstabe, keine Ziffer danach (Wortende). */
const NACH = '(?![\\p{L}\\p{N}])';

/**
 * Ersetzungen in dieser Reihenfolge („Nrn.“ vor „Nr.“). Kürzel mit Punkt
 * brauchen nur den Wortanfang — der Punkt schließt sie ab („Nr.1“ → „No.1“).
 * Keine Ausgabe trifft ein deutsches Muster (idempotent).
 */
const REGELN: readonly (readonly [RegExp, string])[] = [
    [new RegExp(`${VOR}i\\.\\s*V\\.\\s*m\\.`, 'gu'), 'in conj. with'],
    [new RegExp(`${VOR}Abschn\\.`, 'gu'), 'Sect.'],
    [new RegExp(`${VOR}Nrn\\.`, 'gu'), 'Nos.'],
    [new RegExp(`${VOR}Nr\\.`, 'gu'), 'No.'],
    [new RegExp(`${VOR}Anh\\.`, 'gu'), 'Annex'],
    [new RegExp(`${VOR}Ziff\\.`, 'gu'), 'Item'],
    [new RegExp(`${VOR}Kap\\.`, 'gu'), 'Chap.'],
    [new RegExp(`${VOR}Pkt\\.`, 'gu'), 'Pt.'],
    [new RegExp(`${VOR}Abs\\.`, 'gu'), 'Para.'],
    [new RegExp(`${VOR}bzw\\.`, 'gu'), 'or'],
    [new RegExp(`${VOR}Teil${NACH}`, 'gu'), 'Part'],
    [new RegExp(`${VOR}Anlage${NACH}`, 'gu'), 'Appendix'],
    [new RegExp(`${VOR}und${NACH}`, 'gu'), 'and'],
    [new RegExp(`${VOR}sowie${NACH}`, 'gu'), 'and'],
    [new RegExp(`${VOR}bis${NACH}`, 'gu'), 'to'],
];

/** Titel in Anführungszeichen bleiben unberührt (Eigennamen der Regelwerke). */
const ZITAT = /„[^“”"]*[“”"]|“[^”]*”|"[^"]*"|»[^«]*«/g;

const teilUebersetzen = (teil: string): string => REGELN.reduce((t, [muster, ersatz]) => t.replace(muster, ersatz), teil);

/** Deutsche Kurzform der Vorschrift → englische Kurzform. Kein Text → ''. */
export function vorschriftEnglisch(deutsch: string): string {
    if (typeof deutsch !== 'string' || !deutsch) return '';
    let aus = '';
    let pos = 0;
    for (const zitat of deutsch.matchAll(ZITAT)) {
        const start = zitat.index ?? 0;
        aus += teilUebersetzen(deutsch.slice(pos, start)) + zitat[0];
        pos = start + zitat[0].length;
    }
    return aus + teilUebersetzen(deutsch.slice(pos));
}
